import React from 'react'
import { concatStyles } from 'utils'

const DIVIDER_STYLES = 'flex bg-contentareaborder'
const VERTICAL_STYLES = 'w-px'
const HORIZONTAL_STYLES = 'h-px'

const FLEX = { flex: '0 0 1px' }

export interface DividerProps {
  vertical?: boolean
  className?: string
}

export const Divider: React.FC<DividerProps> = ({
  vertical = false,
  className,
}) => (
  <div
    style={FLEX}
    className={concatStyles([
      DIVIDER_STYLES,
      vertical ? VERTICAL_STYLES : HORIZONTAL_STYLES,
      className,
    ])}
  />
)

Divider.displayName = 'Content.Divider'
